import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

type ConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onCancel: () => void;
  isLoading: boolean;
  name: string;
};

export const DeleteConfirmModal: FC<ConfirmModalProps> = (props) => {
  const { open, onClose, onSuccess, onCancel, isLoading, name } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: '380px' } }}>
      <DialogTitle>{t('users-and-roles.roles.delete.modal.title')}</DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>{t('users-and-roles.roles.delete.modal.text', { name })}</DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={() => onSuccess()} disabled={isLoading}>
          {t('users-and-roles.roles.delete.modal.delete-btn')}
        </Button>
        <Button variant="outlined" onClick={() => onCancel()} disabled={isLoading}>
          {t('users-and-roles.roles.delete.modal.cancel-btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
